var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortingDown = function SvgSortingDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 8,
    "data-width-24": 11,
    viewBox: "0 0 7.6 12.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.195 11.417V1.97L1.007 3.99a.6.6 0 0 1-.814-.882L3.389.16a.6.6 0 0 1 .813 0L7.4 3.11a.6.6 0 1 1-.815.882L4.396 1.97v9.447a.6.6 0 1 1-1.2 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortingDown);
export default ForwardRef;